import { Check } from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import copyAllIcon from '../../../assets/copy-link.svg';
import zeplinColor from '../../../theme/Color';

const CopyableTextMUI = ({ textToCopy }: { textToCopy: string }) => {
  const [copied, setCopied] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        position: 'relative',
        '&:hover .copy-button': {
          opacity: 1,
        },
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Typography variant='responsiveBody2' component='span' color={zeplinColor.Brand1}>
        {textToCopy}
      </Typography>

      <Tooltip title={copied ? 'Copied!' : 'Copy to clipboard'} placement='top'>
        <IconButton
          onClick={handleCopy}
          className='copy-button'
          size='small'
          sx={{
            p: 0,
            ml: 0.5,
            transition: 'opacity 0.2s',
            opacity: isHovered || copied ? 1 : 0,
            color: zeplinColor.Neutral11,
          }}
          aria-label='Copy to clipboard'
        >
          {copied ? (
            <Check fontSize='inherit' color='success' />
          ) : (
            <img src={copyAllIcon} alt='copy to clipboard icon' width={18} height={18} />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default CopyableTextMUI;
